// import Swiper from "swiper"
import { find } from "../utils/dom"
import gsap from "gsap"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return
	console.log('Page home');

var swiperUnlock = new Swiper(".swiper-unlock", {
		spaceBetween: 24,
		slidesPerView: 'auto',
		centeredSlides:true,
		initialSlide: 1,
		freeMode:true,
		navigation: {
			nextEl: ".swiper-button-unlock-next",
			prevEl: ".swiper-button-unlock-prev",
		},
		breakpoints: {
			0: {
				spaceBetween: 16,
				slidesPerView: 'auto',
			},
			1024:{
				slidesPerView:3,
				spaceBetween: 0,
			}
		},
		on: {
			slideChange: function () {
				const slidesUnlock = document.querySelectorAll('.swiper-unlock .swiper-slide')					
				slidesUnlock.forEach(i=>{
						i?.classList.remove('border-unlock-active')
						const text = i.querySelector('.bloco-texto')
						text?.classList.remove('active')
				})
				const text = slidesUnlock[this.activeIndex].querySelector('.bloco-texto')
				text?.classList.add('active')
				slidesUnlock[this.activeIndex].classList.add('border-unlock-active')
				//const activeSlide = this.slides[this.activeIndex];

				const program = this.slides[this.activeIndex].dataset.program
				const linkProgram = document.querySelector('[data-program-link]')
				
				if (program === 'Adults'){
					linkProgram.innerText = `Explore the ${program} Program`
					linkProgram.href = `/${program}-program`
				}

				if (program === 'Kids'){
					linkProgram.innerText = `Explore the ${program} Program`
					linkProgram.href = `/${program}-program`
				}

				if (program === 'Muay Thai'){
					linkProgram.innerText = `Explore the ${program} Program`
					linkProgram.href = `/muay-thai-program`
				}

				if (program === 'Yoga'){
					linkProgram.innerText = `Explore the ${program} Program`
					linkProgram.href = `/yoga-program`
				}
			}
		}
		
});
	
const initslideTop = () =>{
		var swiperSpeedTop = new Swiper(".swiper-frame-speed-top", {
				spaceBetween: 16,
				slidesPerView: 'auto',
				loop: true,
				speed: 2000,

				autoplay:{
					delay:1,
					disableOnInteraction: false,
				},
			
				on: {
					init: function () {
						this.el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'linear';
						this.el.querySelector('.swiper-wrapper').style.willChange = 'transform';
					},
				},
			});
}

const initslideCenter = () => {
 var swiperSpeedCenter =  new Swiper(".swiper-frame-speed-center", {
			spaceBetween: 16,
			slidesPerView: 'auto',
			loop: true,
			speed: 1900,

			autoplay:{
				delay:1,
				reverseDirection: true,
    		disableOnInteraction: false,
			},
		
			on: {
				init: function () {
					this.el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'linear';
					this.el.querySelector('.swiper-wrapper').style.willChange = 'transform';
				},
			},
		});
};

const initslideBottom = () =>{
		var swiperSpeedBottom = new Swiper(".swiper-frame-speed-bottom", {
			spaceBetween: 16,
			slidesPerView: 'auto',
			loop: true,
			speed: 2000,

			autoplay:{
				delay:1,
				disableOnInteraction: false,
			},
		
			on: {
				init: function () {
					this.el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'linear';
					this.el.querySelector('.swiper-wrapper').style.willChange = 'transform';
				},
			},
		});
}

const changeTextCardUnlock = () =>{
	const slidesUnlock = document.querySelectorAll('.swiper-unlock .swiper-slide')
	slidesUnlock?.forEach(slide=>{
		const btnLeadMore = slide.querySelector('[data-btn-saiba-mais]')
		btnLeadMore.addEventListener('click', ()=>{
			const seta = btnLeadMore.querySelector('svg')
			const textBack = btnLeadMore.querySelector('[data-text-back]')
			const textMore = btnLeadMore.querySelector('[data-text-more]')
			const background = slide.querySelector('[data-background-slide]')
			const blockText = slide.querySelector('[data-expand-text]')

			blockText?.classList.toggle('text-clamp-hidden')
			background?.classList.toggle('active')
			seta?.classList.toggle('rotate-180')
			textBack?.classList.toggle('text-show')
			textMore?.classList.toggle('text-show')
		})
	})
}

var swiperLocationHome = new Swiper(".swiper-location-home", {
	spaceBetween: 0,
	slidesPerView: 'auto',
	breakpoints: {
		450: {
			spaceBetween: 16,
		},
	},
});

var swiperLegacy = new Swiper(".swiper-legacy", {
	spaceBetween: 16,
	slidesPerView: 'auto',
});

var swiperWordsLegacy = new Swiper(".swiper-words-legacy", {
	spaceBetween: 16,
	slidesPerView: 'auto',
	centeredSlides:true,
	initialSlide: 1,

	navigation: {
		nextEl: ".swiper-button-words-legacy-next",
		prevEl: ".swiper-button-words-legacy-prev",
	},

	on: {
		slideChange: function () {
			const slidesUnlock = document.querySelectorAll('.swiper-words-legacy .swiper-slide')
			slidesUnlock.forEach(i=>{
				const card = i.querySelector('.card-words-legacy')
				card.classList.remove('active')
				//console.log(i);
			})
		
			const activeSlide = this.slides[this.activeIndex].querySelector('.card-words-legacy');
			activeSlide.classList.add('active')
			//console.log('Slide ativo mudou para:', activeSlide);
		}
	}
});

const animaRotateImage = () =>{
	gsap.to("#rotatingText", {
			rotation: 360,
			duration: 10,
			repeat: -1,
			ease: "linear",
			transformOrigin: "50% 50%"  // gira em torno do centro
		});
}

changeTextCardUnlock()
animaRotateImage()

initslideTop()
initslideBottom()
initslideCenter()

}
